var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlertLevelPending = function SvgAlertLevelPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.645 2.625a.75.75 0 0 0-1.3 0l-9.58 16.6a.75.75 0 0 0 .65 1.125h19.17a.75.75 0 0 0 .65-1.125z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    fillRule: "evenodd",
    d: "M12.861 2.5a1 1 0 0 0-1.732 0l-1.5 2.6 1.732 1L11.995 5 12.63 6.1l1.732-1zM8.32 7.38l-4.61 7.98 1.732 1 4.61-7.98zM1.55 19.1l1.5-2.6 1.732 1-.635 1.1h1.269v2h-3a1 1 0 0 1-.866-1.5m6.496 1.5h9.22v-2h-9.22zm12.906-4.1 1.5 2.6a1 1 0 0 1-.866 1.5h-3v-2h1.268l-.634-1.1zm-1.32-2.28-4.61-7.98-1.732 1 4.61 7.98z",
    clipRule: "evenodd"
  })));
};
export default SvgAlertLevelPending;